import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { setMobileTextColor, setMobileBackColor } from "../utility";
import { t } from "i18next";

const Loading = React.memo(({ backColor, message }) => {
  const bgColor = backColor || setMobileBackColor() || "transparent";

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        backgroundColor: bgColor,
        animation: "fadeIn 0.3s ease-in",
        "@keyframes fadeIn": {
          from: { opacity: 0 },
          to: { opacity: 1 },
        },
      }}
    >
      <CircularProgress
        size={40}
        thickness={4}
        sx={{ color: setMobileTextColor() || "#6ba5f2" }}
      />
      {message && (
        <Typography
          className="sub-font"
          sx={{
            color: setMobileTextColor(),
            fontSize: "14px",
            opacity: 0.7,
            mt: 1,
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
});

export default Loading;
